"use client"

import React from "react"

const bannerStyles: React.CSSProperties = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  zIndex: 99999,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "12px",
  padding: "8px 16px",
  backgroundColor: "#f59e0b",
  color: "#000",
  fontSize: "14px",
  fontWeight: 600,
  textAlign: "center",
  direction: "ltr",
}

const linkStyles: React.CSSProperties = {
  color: "#000",
  textDecoration: "underline",
  fontWeight: 700,
  cursor: "pointer",
}

export default function PreviewBanner() {
  return (
    <div style={bannerStyles}>
      <span>Preview Mode — You are viewing unpublished content</span>
      <a href="/api/exit-draft" style={linkStyles}>
        Exit Preview
      </a>
    </div>
  )
}
